"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductType = void 0;
var ProductType;
(function (ProductType) {
    ProductType["US_RD"] = "US_RD";
    ProductType["US_ASC"] = "US_ASC";
    ProductType["CA_SRED"] = "CA_SRED";
})(ProductType || (exports.ProductType = ProductType = {}));
